import engine from "store/src/store-engine";

import localStorage from "store/storages/localStorage";
import sessionStorage from "store/storages/sessionStorage";

import storeExpirePlugin from "store/plugins/expire";
import storeUpDatePlugin from "store/plugins/update";

/**
 * 分转化成元 参数
 * @param {number} price 传入要转化的价格
 */
export const centToDollar = price => (price / 100).toFixed(2);

/**
 * 判断是否整数 参数
 * @param {number} number 要判断的数字
 */
export const isInteger = number => number % 1 === 0;

/**
 * 生成className 参数
 * @param {object} obj 传入对象，key值为className,value值为条件
 */
export const genClassName = obj => Object.keys(obj).filter(item => obj[item]).join(" ");

/**
 * 度数 参数
 * @param {number} deg 所需度数
 */
export const deg = deg => Math.PI / 180 * deg;

/**
 * 获取URL query 参数
 * @param {*} name query param name
 * @param {*} url
 */
export const getUrlParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[[]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

/**
 * 获取URL query
 */
export const getUrlParams = () => {
  let queryString = decodeURIComponent(window.location.search.substring(1));
  let obj = {};
  queryString.split('&').forEach(item => {
    let keyNvalue = item.split('=');
    obj[keyNvalue[0]] = decodeURI(keyNvalue[1]);
  });
  return obj
}

/**
 * 去除对象中空值属性
 * @param obj
 */
export const deleteEmptyProperty = (obj) => {
  let object = JSON.parse(JSON.stringify(obj));
  for (let i in object) {
    let value = object[i];
    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        if (value.length === 0) {
          delete object[i];
          continue;
        }
      }
      deleteEmptyProperty(value);
      if (isEmpty(value)) {
        delete object[i];
      }
    } else {
      if (value === '' || value === null || value === undefined) {
        delete object[i];
      }
    }
  }
  return object;
}

/**
 * 检测对象/数组是否为空
 * @param object 
 */
export const isEmpty = (object) => {
  for (let name in object) {
    return false;
  }
  return true;
}

/**
 * 持久化工具对象
 * session => sessionStorage
 * local => localStorage
 *
 * 加入expire plugin ，可以设置某些存储内容过期时间，如token citylist等
 * local.set('foo', 'bar', new Date().getTime() + 3000)  // 3秒后会删除foo:bar 的数据
 */
export const Session = engine.createStore(sessionStorage, [
  storeExpirePlugin,
  storeUpDatePlugin
]);

export const Local = engine.createStore(localStorage, [
  storeExpirePlugin,
  storeUpDatePlugin
]);

/**
 * 获取列表（dom）当前滑动的高度
 * @param {*} dom 列表dom
 */
export const getScrollHeight = dom => document.querySelector(dom).scrollTop

/**
 * 页面滚动到指定位置
 * @param {*} dom 列表dom
 * @param {*} height 滚动位置
 */
export const scrollToPosition = (dom, height) => document.querySelector(dom).scrollTop = height

/**
 * 七牛图片url压缩转换
 * @param {*} origin 原始七牛图片地址 
 * @param {*} width 压缩指定的宽，不压缩传0
 * @param {*} height 压缩指定的高，不压缩传0
 */
export const transformSmallPicWithQiniu = (origin, width = 0, height = 0) => {
  const QINIU_HTTP_URL_SUFFIX = 'http://qiniu.xbed.com.cn/'
  const QINIU_HTTPS_URL_SUFFIX = 'https://qiniu.xbed.com.cn/'
  const QINIU_COMPRESS_SUFFIX = `?imageView2/2/w/${width}/h/${height}`

  const QINIU_TEST_HTTP_URL_SUFFIX = 'http://p09im61td.bkt.clouddn.com/'
  const QINIU_TEST_HTTPS_URL_SUFFIX = 'https://p09im61td.bkt.clouddn.com/'

  if (origin.match(QINIU_HTTP_URL_SUFFIX) || origin.match(QINIU_HTTPS_URL_SUFFIX) || origin.match(QINIU_TEST_HTTP_URL_SUFFIX) || origin.match(QINIU_TEST_HTTPS_URL_SUFFIX)) {
    return `${origin}${QINIU_COMPRESS_SUFFIX}`
  } else {
    return origin
  }
}

/**
 * 比较两个数组是否一样
 * @param {array} compare 要比较的数组1
 * @param {array} toCompare 要比较的数组2
 */
export const compareArray = (compare, toCompare) =>
  JSON.stringify(compare) === JSON.stringify(toCompare)

/**
 * 正则检测
 */
export const regExp = {
  isRealname: (name) => /(?!.*先生.*|.*小姐.*|.*男士.*|.*女士.*|.*太太.*)^([\u4e00-\u9fa5]{2,10})$/.test(name),
  isIdNo: (idNo) => /(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(idNo),
  isIdCardSuffix: (idCardSuffix) => /^\d{5}(\d|x|X)$/i.test(idCardSuffix),
  isCellPhone: (number) => /^1[3456789][0-9]{9}$/.test(number),
  isEmail: (email) => /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(email)
}

export const genQueryString = (paramObj) => {
  return Object.keys(paramObj).map(key => `${key}=${paramObj[key]}`).join('&')
}

export const curLocation = () => {
  return new Promise((resovle, reject) => {
    let {
      isWx,
      wx,
      navigator
    } = window;

    if (isWx) {
      wx.ready(() => {
        wx.getLocation({
          type: 'wgs84',
          // type: 'gcj02',
          success: function (res) {
            let {
              latitude,
              longitude
            } = res;
            resovle({
              longitude,
              latitude
            })
          },
          fail: function (res) {
            reject(res)
          }
        })
      })
      return
    }

    //第一个函数为用户允许的回调
    //第二个函数为用户禁止的回调            
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        let {
          latitude,
          longitude
        } = pos.coords;
        resovle({
          longitude,
          latitude
        });
      },
      (pos) => {
        reject(pos)
      }, {
        timeout: 1000,
        maximumAge: 0
      }
    )
  })
}


/**
 * 将微信jssdk获取的经纬转化成高德经纬度
 * @param {*} longitude 
 * @param {*} latitude 
 */
export const convertWXLngLat = (longitude, latitude) => {
  return new Promise((resolve, reject) => {
    try {
      new window.AMap.convertFrom([longitude, latitude], 'gps', (status, result) => {
        if (status === 'complete') {
          resolve({ AMaplongitude: result.locations[0].lng, AMaplatitude: result.locations[0].lat })
        } else {
          reject(`AMap.convertFrom status !== complete => status: ${JSON.stringify(status)} ; result: ${JSON.stringify(result)}`);
        }
      })
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * 将高德地图的经纬度逆地理编码为对应的城市
 * @param {*} longitude 
 * @param {*} latitude 
 */
export const queryPositonCity = (longitude, latitude) => {
  return new Promise((resolve, reject) => {
    try {
      new window.AMap.Geocoder().getAddress([longitude, latitude], (status, result) => {
        if (status === 'complete') {
          let city = result.regeocode.addressComponent.city;
          resolve(city)
        } else {
          console.error('AMap.Geocoder().getAddress() 失败 status result', JSON.stringify(status), JSON.stringify(result))
          reject();
        }
      })
    } catch (error) {
      console.error('AMap.Geocoder().getAddress() 错误捕获', JSON.stringify(error))
    }
  })
}

/*
 * 高德地图计算两点间的经纬度相差的距离
 * @param {*} 第一个点的经纬度
 * @param {*} 第二个点的经纬度
 */

export const geometryDistance = (fisrtPointer = {}, secondPointer = {}) => {
  let fisrtLngLat = new window.Amap.LngLat(fisrtPointer.longitude, fisrtPointer.latiude);
  let secondLngLat = new window.Amap.LngLat(secondPointer.longitude, secondPointer.latiude);
  return window.Amap.GeometryUtil.distance(fisrtLngLat, secondLngLat);
}

/**
 * 通过UA检查当前平台是什么
 * 返回（全小写）：
 * ios、android、unknown
 */
export const platformDetector = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('android') != -1 || userAgent.indexOf('linux') != -1) {
    return 'android'
  } else if (userAgent.indexOf('iphone') != -1 || userAgent.indexOf('ipad') != -1 || userAgent.indexOf('ipod') != -1) {
    return 'ios'
  } else {
    return 'unknown'
  }
}

/**
 * 检查是否为函数
 * @param {*} fn 
 */
export const isFunction = (fn) => {
  return Object.prototype.toString.call(fn) === '[object Function]';
}

//上传图片到七牛
// @param qiniuToken 七牛云token
// @param imgFile 上传的图片js文件格式
// @param isPrivate 上传的图片到私有库还是公有库 1 是私有库 
// @param callback 回调 
export const upImageToQiNiu = (qiniuToken, imgFile, isPrivate, callback)=> {
  return new Promise( (resolve, reject) => {
    let newFormData = new FormData();
    newFormData.append('token', qiniuToken);
    newFormData.append('file', imgFile);
    newFormData.append('x:isPrivate', isPrivate); // 1是私有图片上传 必须加上这段
    newFormData.append('enctype', 'multipart/form-data');

    let xhr = new XMLHttpRequest();
    xhr.open('POST', '//upload.qiniu.com');
    xhr.addEventListener('load', async (event) => {
        if(event.target.status >= 200 && event.target.status < 300) {
            let resp = JSON.parse(event.target.response);
            // 成功
            let qiNiuUrl = resp.fileName === 'blob' ? resp.url : resp.materialBase.url; // 七牛图片地址（无法访问）  上传服务器是当前这个地址  判断传递的是blob对象还是文件对象
            // const res = await this.apiInvoke(api => api.queryQiniuPrivateImageUrl(imgUrl, token))
            let newQiNiuUrl = await this.apiInvoke(api => api.queryQiniuPrivateImageUrl(qiNiuUrl), this.token); // 七牛图片地址（可访问）
            !!callback && callback({qiNiuUrl, newQiNiuUrl});
            resolve({qiNiuUrl, newQiNiuUrl})
        
        } else {
            reject({
                status: event.target.status,
                statusText: event.target.statusText
            });
        }
        
    } );
    xhr.addEventListener('error', (event) => {
        // 失败
        console.log(event)
    });
    xhr.send(newFormData);
  })
}

//上传公有图片到七牛
// @param qiniuToken 七牛云token
// @param imgFile 上传的图片js文件格式
// @param callback 回调 
export const upPubImageToQiNiu = (qiniuToken, imgFile, callback)=> {
  return new Promise( (resolve, reject) => {
    let newFormData = new FormData();
    newFormData.append('token', qiniuToken);
    newFormData.append('file', imgFile);
    newFormData.append('enctype', 'multipart/form-data');

    let xhr = new XMLHttpRequest();
    xhr.open('POST', '//upload.qiniu.com');
    xhr.addEventListener('load', async (event) => {
        if(event.target.status >= 200 && event.target.status < 300) {
              // 成功
              let msg = JSON.parse(event.target.response).materialBase;
              !!callback && callback(msg);
              
              resolve(msg)
        
        } else {
            reject({
                status: event.target.status,
                statusText: event.target.statusText
            });
        }
        
    } );
    xhr.addEventListener('error', (event) => {
        // 失败
        console.log(event)
    });
    xhr.send(newFormData);
  })
}





// WEBPACK FOOTER //
// ./src/utils/index.js